import { Node } from '@tiptap/core'
import { Plugin } from 'prosemirror-state'
import { store } from '@/store'

export const ImageChat = Node.create({
  name: 'imageChat',

  defaultOptions: {
    uploadFunc: null,
    HTMLAttributes: {}
  },

  inline: true,
  content: 'inline*',
  group: 'inline',
  draggable: true,
  selectable: false,
  marks: '',

  addAttributes () {
    return {
      src: {
        default: null
      },
      id: {
        default: null
      },
      style: {
        default: 'display: inline-block; max-width: 100%'
      },
      class: {
        default: 'img_chat'
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'span[type="imageChat"]',
        getAttrs: dom => ({
          style: dom.getAttribute('style'),
          src: dom.getAttribute('src'),
          class: dom.getAttribute('class')
        })
      }
    ]
  },

  renderHTML ({ node }) {
    return [
      'span', { type: 'imageChat', ...node.attrs, contenteditable: 'false' },
      ['a', { href: node.attrs.src, target: '_blank' }, ['img', node.attrs]]
    ]
  },

  addCommands () {
    return {
      setImageChat: (options) => ({ tr, dispatch }) => {
        const { selection } = tr

        const node = this.type.create({
          id: options.id,
          src: options.url
        })

        if (dispatch) {
          tr.replaceRangeWith(selection.from, selection.to, node)
        }

        return true
      }
    }
  },

  addProseMirrorPlugins () {
    const upload = this.options.uploadFunc
    const { editor } = this

    return [
      new Plugin({
        props: {
          handleDOMEvents: {
            click (view, event) {
              return event.preventDefault()
            },
            paste (view, event) {
              const items = (event.clipboardData || event.originalEvent.clipboardData).items
              if (!upload) return

              items.forEach(async item => {
                const { schema } = editor.state
                const image = item.getAsFile()

                // Return here, otherwise copying texts won't possible anymore
                if (!image) return

                event.preventDefault()

                const result = await upload(image)

                if (result) {
                  const node = schema.nodes.imageChat.create({
                    src: result.url,
                    id: result.id
                  })
                  const transaction = editor.state.tr.replaceSelectionWith(node)
                  view.dispatch(transaction)
                }
              })
            },
            drop (view, event) {
              const hasFiles = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length

              if (!hasFiles) return

              const images = Array
                .from(event.dataTransfer.files)
                .filter(file => (/image/i).test(file.type))

              if (images.length === 0) return

              event.preventDefault()

              if (images.length > 1) {
                store.commit('setNotification', { isVisible: true, message: 'You can upload only one image per time', color: 'error' })
                return
              }

              const { schema } = editor.state
              const coordinates = view.posAtCoords({ left: event.clientX, top: event.clientY })

              images.forEach(async image => {
                const result = await upload(image)
                if (result) {
                  const node = schema.nodes.imageChat.create({
                    src: result.url,
                    id: result.id
                  })
                  const transaction = editor.state.tr.insert(coordinates.pos, node)
                  view.dispatch(transaction)
                }
              })
            }
          }
        }
      })
    ]
  }
})
